<template>
  <el-dialog
    title="Csomag hozzáadása"
    :visible="true"
    width="900px"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <el-form
      ref="packingForm"
      label-position="top"
      :model="packing"
      :rules="rules"
      v-loading="loading"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="Típus"
            prop="typet"
          >
            <el-select
              v-model="packing.type"
              style="width: 100%;"
              @change="resetForm"
            >
              <el-option
                value="inPacking"
                label="Becsomagolás"
              />
              <el-option
                value="outPacking"
                label="Kicsomagolás"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="Raktár"
            prop="storage_id"
          >
            <el-select
              v-if="storages && storages.length"
              default-first-option
              v-model="packing.storage_id"
              style="width: 100%;"
              filterable
              clearable
            >
              <el-option
                v-for="storage in storages"
                v-if="storage.type === 'own'"
                :key="storage.id"
                :value="storage.id"
                :label="storage.name"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <div
        style="border: 1px solid #b7b7b7;padding: 20px 10px;border-radius: 3px;margin-bottom: 20px;"
      >
        <el-alert
          v-if="packing.type === 'outPacking'"
          type="error"
          :closable="false"
          style="margin-bottom: 20px; padding-left: 5px;"
        >
          <template slot="title">
            <i class="el-icon-caret-bottom"></i> Raktárból ki
          </template>
          Kicsomagolás esetén az itt választott terméknek csökkeni fog a készlete a megadott raktárban.
        </el-alert>
        <el-alert
          v-if="packing.type === 'inPacking'"
          type="success"
          :closable="false"
          style="margin-bottom: 20px; padding-left: 5px;"
        >
          <template slot="title">
            <i class="el-icon-caret-top"></i> Raktárba be
          </template>
          Becsomagolás esetén az itt választott terméknek növekedni fog a készlete a megadott raktárban.
        </el-alert>
        <el-row :gutter="20"
          style="margin-bottom: 0;"
        >
          <el-col :span="6">
            <el-form-item
              label="Termék"
              prop="product"
              style="margin-bottom: 0;"
            >
              <el-select
                v-model="packing.product"
                style="width: 100%;margin-bottom: 0;"
                filterable
                value-key="id"
                :disabled="!packing.storage_id"
                @change="onProductChange"
              >
                <el-option
                  v-for="product in products"
                  :key="product.id"
                  :value="product"
                  :label="product.name"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="Mennyiség"
              prop="count"
              style="margin-bottom: 0;"
            >
              <el-input
                v-model.number="packing.count"
                style="margin-bottom: 0;"
                :disabled="!packing.storage_id"
                @change="onCountChange"
              >
                <template v-if="packing.type === 'outPacking'"
                  slot="prepend">-
                </template>
                <template v-if="packing.type === 'inPacking'"
                  slot="prepend">+
                </template>
                <template slot="append">db</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              prop="supplier"
              label="Beszállító"
              v-loading="packing.type === 'outPacking' && stockLoading"
              style="margin-bottom: 0;"
            >
              <el-select
                v-if="packing.type === 'outPacking'"
                v-model="packing.supplier"
                style="width: 100%;margin-bottom: 0;"
                value-key="id"
                filterable
                :disabled="!packing.storage_id"
                no-data-text="Nincs készleten"
                @change="onSupplierChange"
              >
                <el-option
                  v-for="supp in sourceSuppliers"
                  :key="supp.id"
                  :value="supp"
                  :label="`#${supp.id} ${supp.company.name}`"
                >
                  #{{ supp.id }} {{ supp.company.name }}
                  <span
                    style="float: right; color: #8492a6; font-size: 13px; margin-left: 20px;"
                  >
                    <el-tag
                      size="mini"
                      type="info"
                    >
                      {{ supp.count || 0 }} db készleten
                    </el-tag>
                  </span>
                </el-option>
              </el-select>
              <el-select
                v-if="packing.type === 'inPacking'"
                v-model="packing.supplier"
                style="width: 100%;margin-bottom: 0;"
                value-key="id"
                filterable
                :disabled="!packing.storage_id"
                @change="onSupplierChange"
              >
                <el-option
                  v-for="supp in packing.product.suppliers"
                  :key="supp.id"
                  :value="supp"
                  :label="`#${supp.id} ${supp.company.name}`"
                >
                  #{{ supp.id }} {{ supp.company.name }}
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              prop="source_expiration_date"
              label="Szav. idő"
              style="margin-bottom: 0;"
              v-loading="packing.type === 'outPacking' && stockLoading"
            >
              <el-select
                v-if="packing.type === 'outPacking'"
                v-model="packing.source_expiration_date"
                :disabled="!packing.storage_id"
                no-data-text="Nincs készleten"
                style="margin-bottom: 0;"
              >
                <el-option
                  v-for="exp in sourceExpirationDates"
                  :key="exp.id"
                  :value="exp.expiration_date"
                  :label="$options.filters.date(exp.expiration_date)"
                >
                  {{ exp.expiration_date | date }}
                  <span
                    v-if="exp.count"
                    style="float: right; color: #8492a6; font-size: 13px; margin-left: 20px;"
                  >
                  <el-tag
                    size="mini"
                    type="info"
                  >
                    {{ exp.count }} db készleten
                  </el-tag>
                </span>
                </el-option>
              </el-select>
              <el-date-picker
                v-if="packing.type === 'inPacking'"
                v-model="packing.source_expiration_date"
                :disabled="!packing.storage_id"
                type="date"
                style="width: 100%;"
                :clearable="false"
                format="yyyy. MM. dd."
                value-format="yyyy-MM-dd"
                :picker-options="{ firstDayOfWeek: 1 }"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div
        style="text-align: center;margin-bottom: 20px;font-size: 50px;font-weight: 600;"
      >
        <i v-if="packing.type === 'outPacking'"
          class="el-icon-bottom"></i>
        <i v-if="packing.type === 'inPacking'"
          class="el-icon-top"></i>
      </div>
    </el-form>
    <div v-if="packing.product && packing.ingredients && packing.ingredients.length">
      <el-table
        :data="packing.ingredients"
        border
      >
        <el-table-column
          prop="ingredient.name"
          label="Összetevő"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.name }} <br>
            <el-tag
              v-if="scope.row.count > 0"
              size="mini"
              type="success"
            >
              <i class="el-icon-caret-top"></i> Raktárba be
            </el-tag>
            <el-tag
              v-if="scope.row.count < 0"
              size="mini"
              type="danger"
            >
              <i class="el-icon-caret-bottom"></i> Raktárból ki
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="count"
          label="Mennyiség"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ getIngredientCount(scope.row) }} db
          </template>
        </el-table-column>
        <el-table-column
          label="Beszállító"
        >
          <template slot-scope="scope">
            <el-select
              v-if="!scope.row.stock"
              v-model="scope.row.supplier"
              style="width: 100%;"
              value-key="id"
              filterable
              v-loading="scope.row.stockLoading"
              @change="supplier => onRowSupplierChange(supplier, scope.row)"
            >
              <el-option
                v-for="supp in scope.row.suppliers"
                :key="supp.id"
                :value="supp"
                :label="`#${supp.id} ${supp.company.name}`"
              >
                #{{ supp.id }} {{ supp.company.name }}
              </el-option>
            </el-select>
            <el-select
              v-if="!!scope.row.stock"
              v-model="scope.row.supplier"
              style="width: 100%;"
              value-key="id"
              filterable
              v-loading="scope.row.stockLoading"
              no-data-text="Nincs készleten"
              @change="supplier => onRowSupplierChange(supplier, scope.row)"
            >
              <el-option
                v-for="supp in scope.row.stock.suppliers"
                :key="supp.id"
                :value="supp"
                :label="`#${supp.id} ${supp.company.name}`"
              >
                #{{ supp.id }} {{ supp.company.name }}
                <span
                  style="float: right; color: #8492a6; font-size: 13px; margin-left: 20px;"
                >
                  <el-tag
                    size="mini"
                    type="info"
                  >
                    {{ supp.count || 0 }} db készleten
                  </el-tag>
                </span>
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          label="Szav. ido"
        >
          <template slot-scope="scope">
            <el-date-picker
              v-if="!scope.row.stock"
              v-model="scope.row.expiration_date"
              v-loading="scope.row.stockLoading"
              type="date"
              style="width: 100%;"
              :clearable="false"
              format="yyyy. MM. dd."
              value-format="yyyy-MM-dd"
              :picker-options="{ firstDayOfWeek: 1 }"
            />
            <el-select
              v-if="!!scope.row.stock"
              v-model="scope.row.expiration_date"
              no-data-text="Nincs készleten"
            >
              <el-option
                v-for="exp in scope.row.availableExpirationDates"
                :key="exp.id"
                :value="exp.expiration_date"
                :label="$options.filters.date(exp.expiration_date)"
              >
                {{ exp.expiration_date | date }}
                <span
                  v-if="exp.count"
                  style="float: right; color: #8492a6; font-size: 13px; margin-left: 20px;"
                >
                  <el-tag
                    size="mini"
                    type="info"
                  >
                    {{ exp.count }} db készleten
                  </el-tag>
                </span>
              </el-option>
            </el-select>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="handleClose">
        Mégse
      </el-button>
      <el-button
        type="primary"
        :loading="buttonLoading"
        @click="store"
      >
        Hozzáadaás
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: ['type'],
  data() {
    return {
      loading: false,
      buttonLoading: false,
      stockLoading: false,
      sourceStock: {},
      sourceSuppliers: [],
      sourceExpirationDates: [],
      packing: {
        storage_id: null,
        product_id: null,
        product: {
          suppliers: [],
        },
        source_expiration_date: null,
        supplier: {},
        ingredients: [],
        source_supplier_id: null,
        type: 'outPacking',
        count: 1,
      },
      products: [],
      rules: {
        product: [
          {
            required: true,
            message: 'Mező megadása kötelező',
            trigger: 'change'
          }
        ],
        storage_id: [
          {
            required: true,
            message: 'Mező megadása kötelező',
            trigger: 'change'
          }
        ],
        count: [
          {
            required: true,
            message: 'Mező megadása kötelező',
            trigger: 'change'
          },
          { type: 'number', message: 'Mező csak számot tartalmazhat' }
        ],
        supplier: [
          {
            required: true,
            validator: (rule, value, callback) => {
              callback(value && value.id ? undefined : new Error('Mező megadása kötelező'));
            },
            trigger: 'change'
          }
        ],
        source_expiration_date: [
          {
            required: true,
            message: 'Mező megadása kötelező',
            trigger: 'change'
          }
        ],
      },
    };
  },
  computed: {
    storages() {
      return this.$store.getters['storage/storages'];
    },
  },

  async mounted() {
    this.loading = true;
    await Promise.all([
      this.$store.dispatch('storage/fetchAll'),
    ]);
    this.products = await axios.get('api/packings/products');
    this.loading = false;
  },
  methods: {
    resetForm(type) {
      this.packing = {
        ...this.packing,
        product_id: null,
        product: {
          suppliers: [],
        },
        source_expiration_date: null,
        supplier: {},
        ingredients: [],
        source_supplier_id: null,
        type,
        count: 1,
      };
      this.loading = false;
      this.buttonLoading = false;
      this.stockLoading = false;
      this.sourceStock = {};
      this.sourceSuppliers = [];
      this.sourceExpirationDates = [];
    },
    getIngredientCount(ingredient) {
      return !isNaN(this.packing.count)
        ? (
          this.packing.type === 'outPacking'
            ? (ingredient.base_count || ingredient.count) * this.packing.count
            : (-1 * (ingredient.base_count || ingredient.count) * this.packing.count)
        )
        : 0;
    },
    handleClose() {
      this.$confirm('Biztosan elveted a módosításokat?', {
        confirmButtonText: 'Igen',
        type: 'warning',
      })
      .then(() => {
        this.$router.replace('/processes/packings');
      })
      .catch(() => {
      });
    },

    onCountChange() {
      this.packing.ingredients = this.packing.ingredients.map(productIngredient => ({
        ...productIngredient,
        count: this.getIngredientCount(productIngredient),
      }));
    },

    async onProductChange(product) {
      this.packing.ingredients = [];
      this.sourceExpirationDates = [];
      this.packing.source_expiration_date = null;
      this.packing.supplier = null;
      this.packing.source_supplier_id = null;
      this.stockLoading = true;
      this.packing.product_id = product.id;
      this.packing.product = product;
      if (this.packing.type === 'outPacking') {
        this.sourceStock = await axios.get(`api/products/${this.packing.product_id}/storage/${this.packing.storage_id}`);
        const basePack = this.sourceStock.packs.find(pack => pack.count > 0 && pack.count_per_pack === 1);
        if (basePack && basePack.suppliers) {
          this.sourceSuppliers = basePack.suppliers;
        } else {
          this.sourceSuppliers = [];
        }
      }
      this.packing.ingredients = product.ingredients.map(productIngredient => ({
        name: productIngredient.ingredient.name,
        base_count: productIngredient.count,
        count: this.getIngredientCount(productIngredient),
        product_id: productIngredient.ingredient.id,
        suppliers: productIngredient.ingredient.suppliers,
        stockLoading: this.getIngredientCount(productIngredient) < 0
      }));
      for (const ingredient of this.packing.ingredients) {
        if (ingredient.count < 0) {
          const stock = await axios.get(`api/products/${ingredient.product_id}/storage/${this.packing.storage_id}`);
          const basePack = stock.packs.find(pack => pack.count > 0 && pack.count_per_pack === 1);
          if (basePack && basePack.suppliers) {
            ingredient.stock = { suppliers: basePack.suppliers };
          } else {
            ingredient.stock = { suppliers: [] };
          }
          console.log(ingredient.stock);
          ingredient.stockLoading = false;
        }
      }
      this.stockLoading = false;
    },

    async onSupplierChange(supplier) {
      this.packing.supplier = supplier;
      if (supplier && supplier.expirations) {
        this.sourceExpirationDates = supplier.expirations;
      }
    },

    async onRowSupplierChange(supplier, row) {
      row.supplier_id = supplier.id;
      row.supplier = supplier;
      console.log(row, supplier);
      if (!!row.stock) {
        row.availableExpirationDates = row.stock.suppliers.find(supplier => supplier.id === row.supplier_id).expirations;
      }
    },

    async store() {
      this.$refs['packingForm'].validate(async valid => {
        if (valid) {
          if (!this.packing.ingredients || (this.packing.ingredients && this.packing.ingredients.length === 0)) {
            this.$messageWrapper.error('Minden adat megadása kötelező');
            return;
          }
          let hasError = false;
          this.packing.ingredients.forEach(ingredient => {
            if (!ingredient.expiration_date || !ingredient.count || !ingredient.supplier_id || !ingredient.product_id) {
              hasError = true;
            }
          })
          if (hasError) {
            this.$messageWrapper.error('Minden adat megadása kötelező');
            return;
          }
          this.buttonLoading = true;
          try {
            await this.$store.dispatch('packing/create', this.packing);
            this.$store.dispatch('packing/fetchAll');
            this.buttonLoading = false;
            this.$router.replace('/processes/packings');
          } catch (e) {
          }
          this.buttonLoading = false;
        }
      });
    }
  },
};
</script>

